// extracted by mini-css-extract-plugin
module.exports = {"root":"FaqBlock-module--root--Ae-dN","title":"FaqBlock-module--title--3R9FS","html":"FaqBlock-module--html--17p1T"};